import { compass } from '@resclick/compass';
// import { LocalStorage } from "quasar";
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

const LocalStorage = window.localStorage;

@Module({ namespaced: true })
class AuthStore extends VuexModule {
  public accessToken: string = LocalStorage.getItem('accessToken') || '';
  public id: string = LocalStorage.getItem('id') || '';

  @Mutation
  public AUTH_SUCCESS(data: any): void {
    this.accessToken = data.accessToken;
    this.id = data.id;
    LocalStorage.setItem('accessToken', data.accessToken);
    LocalStorage.setItem('id', data.id);
  }

  @Mutation
  public AUTH_FAIL() {
    this.accessToken = '';
    this.id = '';
    LocalStorage.removeItem('accessToken');
    LocalStorage.removeItem('id');
  }

  @Mutation
  public LOGOUT() {
    this.accessToken = '';
    this.id = '';
    LocalStorage.removeItem('accessToken');
    LocalStorage.removeItem('id');
  }

  @Action
  public login(data: { email: string; password: string }) {
    return new Promise((resolve, reject) => {
      compass
        .do('auth', 'login', { data })
        .then((res) => {
          try {
            this.context.commit('AUTH_SUCCESS', res.data);
            compass.httpConfig({
              headers: {
                Authorization: `Bearer ${res.data.accessToken}`,
              },
            });
            this.context.dispatch('user/getProfile', res.data.id, { root: true }).then(() => {
              resolve(res.data);
            });
          } catch (e) {
            throw new Error(e);
          }
        })
        .catch(() => {
          this.context.commit('AUTH_FAIL');
          reject();
        });
    });
  }
}

export default AuthStore;
